import { render, staticRenderFns } from "./_category.vue?vue&type=template&id=576fdb6c"
import script from "./_category.vue?vue&type=script&lang=js"
export * from "./_category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IdSearch: require('/workspace/components/Search.vue').default,IdNavigationSideLinks: require('/workspace/components/navigation/SideLinks.vue').default,IdNavigationMobileNavButton: require('/workspace/components/navigation/MobileNavButton.vue').default,IdCategoryDescription: require('/workspace/components/category/Description.vue').default,IdCategoryChildren: require('/workspace/components/category/Children.vue').default,IdCategorySingleDiagram: require('/workspace/components/category/SingleDiagram.vue').default})
